/**
 * Testi italiani dello spazio dei siti ospitati e dei crediti (ADR 0046).
 *
 * Lo spazio sta nel pannello Hosting del progetto; i crediti nella pagina «Abbonamento e
 * pagamenti». Il prezzo e i GiB arrivano dal backend: i testi non li scrivono a mano.
 */

/** Testi dello spazio e dei crediti. */
export const storage = {
  /** Sezione «Spazio» nel pannello Hosting. */
  section: {
    /** Titolo della sezione. */
    title: 'Spazio',
    /** Che cosa è e quanto costa. */
    intro:
      'È lo spazio che i volumi del sito possono occupare in tutto. Il piano ne include {{included}} GiB. Oltre, ogni GiB costa {{price}} crediti al mese.',
    /** Etichette dei dati. */
    included: 'Incluso nel piano',
    chosen: 'Spazio scelto',
    allocated: 'Già occupato dai volumi',
    monthly: 'Costo al mese',
    charged: 'Addebitato questo mese',
    balance: 'Saldo crediti',
    /** Valore in GiB. */
    gib: '{{value}} GiB',
    /** Valore in crediti. */
    credits: '{{value}} crediti',
    /** Nessun costo. */
    free: 'Nessun costo',
    /** Valore non letto. */
    unknown: 'Non disponibile',
    /** Campo del nuovo spazio. */
    field: 'Nuovo spazio in GiB',
    /** Aiuto del campo. */
    fieldHelp: 'Da {{min}} a {{max}} GiB. Un volume già creato non si rimpicciolisce.',
    /** Pulsante. */
    apply: 'Cambia spazio',
    /** Conferma. */
    confirmTitle: 'Cambiare lo spazio?',
    confirmExtra:
      'Il sito potrà occupare {{gib}} GiB. Costo: {{credits}} crediti al mese, scalati ogni giorno dal saldo.',
    confirmIncluded: 'Il sito potrà occupare {{gib}} GiB, inclusi nel piano. Nessun costo.',
    confirm: 'Cambia',
    /** Esiti. */
    done: 'Spazio cambiato.',
    failed: 'Cambio non riuscito. Riprova.',
    loadFailed: 'Spazio non disponibile. Riprova.',
    /** Crediti finiti. */
    unpaidTitle: 'Crediti finiti',
    unpaidText:
      'Lo spazio è sceso a quello già occupato: il sito non può creare altri volumi. I dati restano. Ricarica i crediti e scegli di nuovo lo spazio.',
    /** Collegamento alla pagina dei pagamenti. */
    buyCredits: 'Ricarica i crediti',
    /** Chi guarda non gestisce il progetto. */
    readOnly: 'Lo spazio lo cambia chi gestisce il progetto.',
    /** Rifiuti del backend. */
    refusals: {
      storage_below_included: 'Lo spazio non scende sotto l’incluso del piano.',
      storage_below_allocated: 'I volumi occupano già più spazio. Un volume non si rimpicciolisce.',
      storage_too_large: 'Lo spazio supera il massimo consentito.',
      insufficient_credits: 'Crediti insufficienti per lo spazio in più fino a fine mese. Ricarica i crediti.',
    },
  },
  /** Sezione «Crediti» nella pagina dei pagamenti. */
  credits: {
    /** Titolo della sezione. */
    title: 'Crediti',
    /** Che cosa pagano. */
    intro: 'I crediti pagano lo spazio dei siti oltre l’incluso del piano. 1 credito vale 0,01 €.',
    /** Etichetta del saldo. */
    balance: 'Crediti disponibili',
    /** Titolo della scelta dei tagli. */
    choose: 'Importo della ricarica',
    /** Crediti di un taglio. */
    credits: '{{credits}} crediti',
    /** Bonus di un taglio. */
    bonus: '+{{percent}}%',
    /** Campo dell'importo libero. */
    other: 'Altro importo',
    /** Aiuto del campo. */
    otherHelp: 'Euro interi, da {{min}} a {{max}}.',
    /** Riepilogo prima del pagamento. */
    summary: 'Paghi {{price}} e ricevi {{credits}} crediti.',
    summaryBonus: 'Paghi {{price}} e ricevi {{credits}} crediti, bonus del {{percent}}% compreso.',
    /** Nessun importo valido. */
    pick: 'Scegli un taglio o scrivi un importo da {{min}} a {{max}}.',
    /** Pulsante di acquisto. */
    buy: 'Compra crediti',
    /** Rifiuto del backend: importo fuori dai limiti. */
    amountInvalid: 'Importo non valido. Usa importi interi, senza centesimi, entro i limiti indicati.',
  },
};

/** Forma dei testi dello spazio, per le altre lingue. */
export type Storage = typeof storage;
